var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useCallback } from 'react';
import { styled } from 'styled-components';
import { getGradeIndex, } from '../../../../../../landing/models/GradeInfo';
import { Header } from './Header';
import { SubTable } from './SubTable';
import { useYearlyDashboardAnalytics, YearlyDashboardEvents, } from '../../../hooks/useYearlyDashboardAnalytics';
var Container = styled.section.withConfig({ displayName: "Container", componentId: "sc-14z1qw9" })(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  position: relative;\n"], ["\n  position: relative;\n"])));
var ScHeader = styled(Header).withConfig({ displayName: "ScHeader", componentId: "sc-15denir" })(templateObject_2 || (templateObject_2 = __makeTemplateObject([""], [""])));
var Table = function (_a) {
    var isTeacherPremium = _a.isTeacherPremium, data = _a.data, startGrade = _a.startGrade, endGrade = _a.endGrade, currentGrade = _a.currentGrade, role = _a.role, teacherName = _a.teacherName, isClassPremium = _a.isClassPremium, rest = __rest(_a, ["isTeacherPremium", "data", "startGrade", "endGrade", "currentGrade", "role", "teacherName", "isClassPremium"]);
    var groupedData = data.groupedData;
    var sendGaEvent = useYearlyDashboardAnalytics();
    var onStudentClick = useCallback(function () {
        sendGaEvent(YearlyDashboardEvents.studentLinkClick);
    }, [sendGaEvent]);
    var SubTables = function (props) { return (_jsx(_Fragment, { children: groupedData.map(function (_a) {
            var name = _a.group.name, rows = _a.rows;
            return (_jsx(SubTable, __assign({ rows: rows, groupTitle: name, role: role, teacherName: teacherName, onStudentClick: onStudentClick }, props), name));
        }) }, void 0)); };
    var closingGradePosition = currentGrade === startGrade ? -1 : 1;
    var currentGradePostion = getGradeIndex(currentGrade) - getGradeIndex(startGrade) + 1;
    var nextGradePosition = currentGradePostion + 1;
    return (_jsxs(Container, __assign({ "data-testid": 'Table' }, rest, { role: 'table' }, { children: [_jsx(ScHeader, { nextGradeLinePostion: nextGradePosition, closingLinePostion: closingGradePosition, currentGradeLinePostion: currentGradePostion, startGrade: startGrade, endGrade: endGrade, currentGrade: currentGrade, isTeacherPremium: isTeacherPremium, teacherName: teacherName, role: role }, void 0), _jsx(SubTables, { nextGradeLinePostion: nextGradePosition, closingLinePostion: closingGradePosition, currentGradeLinePostion: currentGradePostion, startGrade: startGrade, endGrade: endGrade }, void 0)] }), void 0));
};
export { Table };
var templateObject_1, templateObject_2;
